module.exports = __webpack_public_path__ + "img/nfc.cfd3dc88.svg";